import type { PropsWithChildren } from 'react';
import { ThemeProvider, createTheme } from '@fluentui/react';
import { webDarkTheme } from '@fluentui/react-components';
import { useTheme } from '@/theme';

const darkPalette = createTheme({
  palette: {
    themePrimary: webDarkTheme.colorBrandForeground1,
    neutralPrimary: webDarkTheme.colorNeutralForeground1,
    neutralPrimaryAlt: webDarkTheme.colorNeutralForeground2,
    neutralSecondary: webDarkTheme.colorNeutralForeground2,
    neutralSecondaryAlt: webDarkTheme.colorNeutralForeground3,
    neutralTertiary: webDarkTheme.colorNeutralForeground4,
    neutralTertiaryAlt: webDarkTheme.colorNeutralStroke1,
    neutralQuaternary: webDarkTheme.colorNeutralStroke2,
    neutralQuaternaryAlt: webDarkTheme.colorNeutralStroke2,
    neutralLight: webDarkTheme.colorNeutralBackground3,
    neutralLighter: webDarkTheme.colorNeutralBackground2,
    neutralLighterAlt: webDarkTheme.colorNeutralBackground1,
    white: webDarkTheme.colorNeutralBackground2,
    black: webDarkTheme.colorNeutralForeground1,
    neutralDark: webDarkTheme.colorNeutralForeground1,
  },
  isInverted: true,
});

const lightPalette = createTheme({});

/** Bridges the app's v9 dark/light mode to the v8 ThemeProvider needed by @fluentui/react-charting. */
export const ChartThemeProvider = ({ children }: PropsWithChildren) => {
  const { isDarkMode } = useTheme();
  return (
    <ThemeProvider theme={isDarkMode ? darkPalette : lightPalette}>
      {children}
    </ThemeProvider>
  );
};
